/**
 * Created by Xuz on 2020/03/25.
 * xuz@live.cn
 *
 * 自循环
 */
import WFHelper from './WFHelper'

const uuidv4 = require('uuid/v4')

class VirtualLine {
  constructor(parent) {
    this.parent = parent
  }

  attr(name) {
    if (name === 'd') {
      let dSvg = this.parent.dSvg
      let dPath = this.parent.dPath

      let p = dSvg.attr('transform')
      let x = p.substring(p.indexOf('(') + 1, p.indexOf(','))
      let y = p.substring(p.indexOf(',') + 1, p.indexOf(')'))
      let pd = dPath.attr(name)
      let ary = pd.split(' ')
      ary[1] = ary[1] * 1 + x * 1
      ary[2] = ary[2] * 1 + y * 1
      ary[9] = ary[9] * 1 + x * 1
      ary[10] = ary[10] * 1 + y * 1
      pd = ary.join(' ')
      return pd
    }
  }
}

class WFRepeat {
  _init () {
    this.sUuid = uuidv4()
    this.dSvg = null
    this.dContainer = null
    this.defaultWidth = null
    this.dPath = null
    this.dText = null
    this.textNode = null
    this.fixY = 22
    this.fixContainerHeight = 40
    this.sAttrName = null
    this.sOwnerId = null
    this.bKilled = false
    this.iOrder = null
    this.bSrc = false

    this.dLine = new VirtualLine(this)
  }

  constructor (workflow) {
    this._init()
    this.workflow = workflow
  }

  uuid () {
    return this.sUuid
  }

  getSvg () {
    return this.dSvg
  }

  setOrder (orderNo) {
    this.iOrder = orderNo
    this.dSvg.attr('wf-link-order', this.iOrder)
  }

  /**
   * 获得连接的线条，这是接口方法
   */
  getLine () {
    return this.dLine
  }

  /**
   * 设置途径路过的风格
   */
  onTrackStyle () {
    this.dPath.attr('style', 'fill:none;stroke:red;stroke-width:1.3;')
    this.dPath.attr('marker-end', 'url(#redArrow)')
  }

  /**
   * 生成循环器，此Create方法与其它不同，其必须提供一个实体
   * 此实体由ToolBar控制器提供
   */
  create (event, el) {
    const oSvgJs = this.workflow.getSvgJs()

    this.sOwnerId = el.uuid()
    // 设置循环器为自己本身
    el.setRepeater(this.sUuid)
    let rect = WFHelper.getRect(el.getSvg())

    this.dSvg = oSvgJs.group()

    let trans = 'translate(' + rect.x + ', ' + (rect.y - this.fixContainerHeight) + ')'
    this.dSvg.attr('transform', trans)
    this.dContainer = oSvgJs.rect()
    this.defaultWidth = rect.width

    this.serial()

    this.dContainer.attr('width', this.defaultWidth)
    this.dContainer.attr('height', '40')
    this.dContainer.attr('fill', 'white')
    this.dContainer.attr('stroke', 'black')
    this.dContainer.attr('stroke-width', '0')
    this.dContainer.attr('style', 'opacity:0')
    this.dContainer.attr('stroke-dasharray', '3,3')

    this.dSvg.add(this.dContainer)

    this.dPath = oSvgJs.path()

    let pathData = 'M ' + parseInt(rect.width / 2 - 15) + ' ' + this.fixContainerHeight + ' '
    pathData += 'A 16 12 0 1 1 '
    pathData += parseInt(rect.width / 2 + 15) + ' ' + parseInt('' + (this.fixContainerHeight - 6))
    this.dPath.attr('id', this.sUuid)
    this.dPath.attr('d', pathData)
    this.dPath.attr('style', 'fill:none;stroke:black;stroke-width:1.3;')
    this.dPath.attr('marker-end', 'url(#arrow)')

    this.dSvg.add(this.dPath)

    let gText = oSvgJs.group()
    this.sAttrName = WFHelper.getNextLinkName()
    this.dText = oSvgJs.text('')
    this.dText.tspan(this.sAttrName).dx(0).dy(0)

    let sTrans = 'translate(0, 15)'
    gText.attr('transform', sTrans)
    gText.add(this.dText)
    this.dSvg.add(gText)

    // _svg.setAttribute('onmousedown', '_WF.doMouseDown(evt)')

    oSvgJs.add(this.dSvg)

    this.workflow.setActiveElement(this, event)
    this.fixLayout()

    this.workflow.registerElement(this)
  }

  /**
   * 修正位置，循环器的位置与其Node是一起变化的，当Node的模子发生改变时会影响
   * 自循环的位置，因此需要修正
   */
  fixLayout () {
    let ownerRect = WFHelper.getRect(this.workflow.getElement(this.sOwnerId).getSvg())
    let containerMinWidth = ownerRect.width

    let textRect = WFHelper.getRect(this.dText)

    //如果字体小于最小限度
    if (textRect.width < containerMinWidth) {
      // 先修正容器的长度
      this.dContainer.attr('width', containerMinWidth)
      let containerRect = WFHelper.getRect(this.dContainer)

      // 修正Svg的Tansform位置
      let trans = 'translate(' + ownerRect.x + ', ' + (ownerRect.y - this.fixContainerHeight) + ')'
      this.dSvg.attr('transform', trans)

      // 修正字体的位置
      let textPosx = (containerMinWidth - textRect.width) / 2
      this.dText.attr('x', textPosx)

      // 修正曲线的位置
      let pathData = 'M ' + parseInt(ownerRect.width / 2 - 15) + ' ' + this.fixContainerHeight + ' '
      pathData += 'A 16 12 0 1 1 '
      pathData += parseInt(ownerRect.width / 2 + 15) + ' ' + parseInt('' + (this.fixContainerHeight - 6))
      this.dPath.attr('d', pathData)

    } else {
      // 如果字体较长
      // 先修正容器的长度
      this.dContainer.attr('width', textRect.width + 4)
      let containerRect = WFHelper.getRect(this.dContainer)

      // 修正Svg的Transform位置
      let transX = (ownerRect.x - (containerRect.width - containerMinWidth) / 2)
      let trans = 'translate(' + transX + ', ' + (ownerRect.y - this.fixContainerHeight) + ')'
      this.dSvg.attr('transform', trans)

      // 修正字体的位置
      let textPosx = (containerRect.width - textRect.width) / 2
      this.dText.attr('x', textPosx)

      // 修正曲线的位置
      let pathData = 'M ' + parseInt(containerRect.width / 2 - 15) + ' ' + this.fixContainerHeight + ' '
      pathData += 'A 16 12 0 1 1 '
      pathData += parseInt(containerRect.width / 2 + 15) + ' ' + parseInt('' + (this.fixContainerHeight - 6))
      this.dPath.attr('d', pathData)
    }
  }

  /**
   * 当鼠标移动时，此事件由其宿主Node触发
   */
  onMove (event, el) {
    let ownerRect = WFHelper.getRect(el.getSvg())
    let containerRect = WFHelper.getRect(this.dContainer)
    let trans = null
    if (containerRect.width > ownerRect.width) {
      trans = 'translate(' + (ownerRect.x - (containerRect.width - ownerRect.width) / 2) + ', ' + (ownerRect.y - this.fixContainerHeight) + ')'
    } else {
      trans = 'translate(' + ownerRect.x + ', ' + (ownerRect.y - this.fixContainerHeight) + ')'
    }
    this.dSvg.attr('transform', trans)
  }

  /**
   * 被选中
   */
  onSelect (event) {
    this.dContainer.attr('stroke-width', '1')
    this.dContainer.attr('style', 'opacity:0.8')
  }

  /**
   * 取消选中
   */
  onUnSelect (event) {
    this.dContainer.attr('stroke-width', '0')
    this.dContainer.attr('style', 'opacity:0')
  }

  /**
   * 鼠标松开
   */
  onUp (event) {
  }

  /**
   * 双击时执行的操作
   */
  onMouseDblClick (event) {
    let parent = this.workflow.getParent()
    parent.onEditLinkNode(this)
  }

  /**
   * 设置SVG上显示的名字
   */
  setName (name) {
    this.sAttrName = name
    this.dText.tspan(this.sAttrName)
  }

  /**
   * 获得名字
   */
  getName () {
    return this.sAttrName
  }

  /**
   * 工具条改变时的回调方法
   */
  onToolbarChange ($tbId) {
  }

  /**
   * 移除自己
   */
  remove () {
    if (this.bKilled) {
      return
    }
    this.dSvg.remove()
    this.bKilled = true

    this.workflow.getElement(this.sOwnerId).setRepeater(null)
    this.workflow.unregisterElement(this)
    return true
  }

  /**
   * 序列化自己的标记位设置
   */
  serial () {
    this.dSvg.attr('uuid', this.sUuid)
    this.dSvg.attr('wf-class', 'WFRepeat')
    this.dSvg.attr('wf-default-width', this.defaultWidth)
    this.dSvg.attr('wf-owner', this.sOwnerId)
  }

  // 是否原始对象
  // 在非编辑模式要判断是否原始对象，原始对象默认是不能删除的
  isSrc () {
    return this.bSrc
  }

  /**
   * 从SVG上恢复为JS封装类实现的方法
   */
  unSerial (svg) {
    this.bSrc = true
    this.dSvg = svg
    this.sUuid = this.dSvg.attr('uuid')
    this.sOwnerId = this.dSvg.attr('wf-owner')
    this.defaultWidth = this.dSvg.attr('wf-default-width')
    this.dContainer = this.dSvg.children()[0]
    this.dPath = this.dSvg.children()[1]
    this.dText = this.dSvg.children()[2].children()[0]
    this.sAttrName = this.dText.text()
    this.iOrder = this.dSvg.attr('wf-link-order')
    this.workflow.registerElement(this)
  }

  /**
   * 获得xml描述节点
   */
  getXmlNode (oXml) {
    let node = oXml.createElement('repeat')
    node.setAttribute('uuid', this.sUuid)
    node.setAttribute('name', this.sAttrName)
    node.setAttribute('owner', this.sOwnerId)
    let r = this.iOrder == null ? '' : this.iOrder
    node.setAttribute('order', r)
    return node
  }

  /**
   * 更新节点的描述信息
   */
  updateXmlNode () {
    const wfXml = this.workflow.getWfXml()
    let node = wfXml.getNode(this.sUuid)
    node.setAttribute('name', this.sAttrName)
  }

  /**
   * 将数据放回表单当中
   */
  pushWFAttributes (formData) {
    const wfXml = this.workflow.getWfXml()
    WFHelper.pushWFFormAttributes(formData, wfXml.getNode(this.sUuid))
  }

  /**
   * 设置于工作流相关的属性
   */
  setWFAttributes (attrName, value) {
    // 传进来的表单的Dom实体
    const wfXml = this.workflow.getWfXml()
    if (attrName === 'FORM') {
      const oXml = wfXml.getXml()
      let nodes = WFHelper.createWFFormAttributesNode(value, oXml)
      let node = wfXml.getNode(this.sUuid)
      WFHelper.removeWFFormAttributes(node)
      for (let i = 0; i < nodes.length; i++) {
        node.appendChild(nodes[i])
      }
    }
  }
}

export default WFRepeat
